export default "__VITE_ASSET__BUojz7RY__"